var map = {
	"./1.svg": "0671",
	"./2.svg": "1f28",
	"./3.svg": "d56c",
	"./4.svg": "c829",
	"./5.svg": "e570",
	"./6.svg": "606b",
	"./7.svg": "e964",
	"./8.svg": "f3c1",
	"./coding-practice.svg": "aa1c",
	"./coding-skills-building.svg": "8d66",
	"./learn-and-teach.svg": "1b35",
	"./master-current-language.svg": "859e",
	"./train-or-fight.svg": "361e",
	"./training-with-others.svg": "36f4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a89e";